import cloneDeep from 'lodash/cloneDeep'
import defaultsDeep from 'lodash/defaultsDeep'
import reduce from 'lodash/reduce'
import actionTypes from 'constants/actionTypes'

interface PermissionMap {
  [id: string]: boolean
}

interface PermissionUser {
  id?: string
}

interface PermissionsNewContentState {
  readers: PermissionMap
  writers: PermissionMap
  expanded: boolean
}

interface PermissionsNewContentAction {
  type?: string
  payload?: {
    id?: string
    readers?: PermissionUser[]
    writers?: PermissionUser[]
  }
}


export default (state: PermissionsNewContentState = {
  readers: {},
  writers: {},
  expanded: false,
}, action: PermissionsNewContentAction): PermissionsNewContentState => {
  state.expanded ??= false
  switch (action.type) {
    case actionTypes.PERMISSIONS.NEW_CONTENT.READERS.ADD: {
      const id = action.payload?.id
      if (!id) return state
      return defaultsDeep(
        {
          readers: { [id]: true }
        },
        state
      )
    }
    case actionTypes.PERMISSIONS.NEW_CONTENT.READERS.REMOVE: {
      const id = action.payload?.id
      if (!id) return state
      const updated = cloneDeep(state)
      delete updated.readers[id]
      delete updated.writers[id]
      return updated
    }
    case actionTypes.PERMISSIONS.NEW_CONTENT.WRITERS.ADD: {
      const id = action.payload?.id
      if (!id) return state
      return defaultsDeep(
        {
          readers: { [id]: true },
          writers: { [id]: true }
        },
        state
      )
    }
    case actionTypes.PERMISSIONS.NEW_CONTENT.WRITERS.REMOVE: {
      const id = action.payload?.id
      if (!id) return state
      const updated = cloneDeep(state)
      delete updated.writers[id]
      return updated
    }
    case actionTypes.PERMISSIONS.NEW_CONTENT.CLEAR: {
      const updated = cloneDeep(state)
      updated.readers = {}
      updated.writers = {}
      return updated
    }
    case actionTypes.PERMISSIONS.NEW_CONTENT.SET: {
      const updated = cloneDeep(state)
      updated.readers = reduce(action.payload?.readers ?? [], (rs: PermissionMap, r: PermissionUser) => {
        if (r.id) rs[r.id] = true
        return rs
      }, {})
      updated.writers = reduce(action.payload?.writers ?? [], (ws: PermissionMap, w: PermissionUser) => {
        if (w.id) ws[w.id] = true
        return ws
      }, {})
      return updated
    }
    case actionTypes.PERMISSIONS.NEW_CONTENT.EXPAND:
      return defaultsDeep(
        {
          expanded: true
        },
        state
      )
    case actionTypes.PERMISSIONS.NEW_CONTENT.COLLAPSE:
      return defaultsDeep(
        {
          expanded: false
        },
        state
      )
  }
  return state
}
